module.exports = __webpack_public_path__ + "static/img/video_0.8703475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_0.jpg
// module id = sUjZ
// module chunks = 1